import styled from 'styled-components';

export const Ocupacao = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 8px;
  justify-content: flex-start;
  position: relative;

  .ocupacao {
    display: flex;
    min-width: 32px;
    font-size: sans-serif;

    .atual {
      margin-right: 0.5rem;
    }

    .limite {
      color: #c1c1c1;
    }
  }

  .progressOcupation {
    min-width: 120px;
    padding-left: 2px;
  }
`;
